/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createVersion } from '../../factoriesAny.js';
export var versionDependencies = {
  createVersion
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesVersion.generated.js
// module id = LZXL
// module chunks = 3